import { Injectable } from '@angular/core';
import { MyClaim, SearchResult } from 'src/app/shared';
import { Http } from 'src/app/shared/services/http.service';

@Injectable({
  providedIn: 'root',
})
export class LogService {
  constructor(private http: Http) {}

  async LogFeature(
    claim: SearchResult,
    FeatureName: string,
    SectionName: string,
    DocumentId: string = ''
  ): Promise<boolean> {
    if (claim != null && claim != undefined && DocumentId == '') {
      const claimId = claim.claimId;
      const source = claim.source;
      const lob = claim.lob;
      const userOwns = claim.userOwns;

      return this.http.post<boolean>(
        `/api/features/${source}/${claimId}/${encodeURIComponent(
          FeatureName
        )}/${lob}/${encodeURIComponent(
          SectionName
        )}/${userOwns}/FeatureLogRequest`,
        null
      );
    } else if (DocumentId == '') {
      return this.http.post<boolean>(
        `/api/features/${encodeURIComponent(FeatureName)}/${encodeURIComponent(
          SectionName
        )}/FeatureLogRequestNoClaim`,
        null
      );
    } else {
      if (claim != null && claim != undefined) {
        const claimId = claim.claimId;
        const source = claim.source;
        const lob = claim.lob;
        const userOwns = claim.userOwns;
        return this.http.post<boolean>(
          `/api/features/${source}/${claimId}/${encodeURIComponent(
            FeatureName
          )}/${lob}/${encodeURIComponent(
            SectionName
          )}/${userOwns}/${DocumentId}/FeatureLogRequestWithClaimWithDocId`,
          null
        );
      } else {
        return this.http.post<boolean>(
          `/api/features/${encodeURIComponent(
            FeatureName
          )}/${encodeURIComponent(
            SectionName
          )}/${DocumentId}/FeatureLogRequestNoClaimWithDocId`,
          null
        );
      }
    }
  }

  async LogFeatureWithClaim(
    claim: MyClaim,
    featureName: string,
    sectionName: string
  ): Promise<boolean> {
    if (claim.claimId != null && claim.claimId != undefined) {
      return this.http.post<boolean>(
        `/api/features/${claim.source}/${claim.claimId}/${encodeURIComponent(
          featureName
        )}/${claim.lineOfBusiness}/${encodeURIComponent(sectionName)}/${
          claim.userOwns
        }/FeatureLogRequest`,
        null
      );
    } else {
      return this.LogFeature(
        null,
        featureName == null || featureName == undefined
          ? 'Issue'
          : 'Issue' + featureName,
        sectionName,
        '00'
      );
    }
  }
}
